import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import * as momenttz from 'moment-timezone';

@Pipe({
  pure: false,
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern = 'shortDate'): any {
    if (value) {
      const date = momenttz.tz(
        moment.unix(value),
        Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      const local = moment(date)
        .local()
        .format('YYYY-MM-DD HH:mm:ss')
        .replace(/\s/g, 'T');
      if (!this.translateService.currentLang) {
        this.translateService.currentLang = localStorage.getItem('language')
          ? localStorage.getItem('language')
          : 'en';
      }
      const datePipe: DatePipe = new DatePipe(
        this.translateService.currentLang
      );

      return datePipe.transform(local, pattern);
    }
  }
}
